import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import API from "../../api"
import {
    Row,
    Col,
    Spinner
    , Label, Form, CardTitle,
} from "reactstrap"
import {withRouter} from "react-router"
import Select from "react-select";
import {Slide, toast, ToastContainer} from "react-toastify";
import FileDownload from "js-file-download"

const DataTablePlanEtudeEtat = props => {
    const [loading, setLoading] = useState(false)
    const [annee, setAnnee] = useState("");
    const [imp, setImp] = useState(0);
    const [excel, setExcel] = useState(0);
    const [enseignant, setEnseignant] = useState([])
    const [selectEnseignant, setSelectEnseignant] = useState("")
    const [departement, setDepartement] = useState([])
    const [selectDepartement, setSelectDepartement] = useState("")
    const [specilaite, setSpecilaite] = useState([])
    const [selectSpecialite, setSelectSpecialite] = useState("")
    var userAuthScolarite = JSON.parse(
      localStorage.getItem("userAuthScolarite")
    )
    var annee_id = userAuthScolarite.user.annee_id
    useEffect(async () => {
        const userAuth = JSON.parse(localStorage.getItem('UserMenu'));
        const typeArticleSubMenu = userAuth.find(user =>
            user.sous_menu.some(subMenu => subMenu.sous_menu === "Etats encadrement")
        );
        setImp(typeArticleSubMenu.sous_menu[0].imp)
        setExcel(typeArticleSubMenu.sous_menu[0].exel)
        var userAuthScolarite = JSON.parse(localStorage.getItem("userAuthScolarite"))
        var annee_id = userAuthScolarite.user.annee_id
        setAnnee(annee_id)
        // cycle
        const res = await API.post("enseignant/select",{annee_id}).then(res => {
            setEnseignant(res.data.select_enseignant)
        })
        await API.get("departement/select").then(resDepartement => {
            setDepartement(resDepartement.data.Departement)
            setSelectDepartement("")
        })
        setLoading(true)
    }, [])
    const uploadPDF = async () => {
        var enseignant_id = selectEnseignant !== "" && selectEnseignant != null ? selectEnseignant.value : 0
        if (enseignant_id === 0) {
            setLoading(true)
            toast.error("⛔  Enseignant est obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            window.open('https://scolarite.backcresus-institut.ovh/api/pdf/cahier_de_suivi_pour_discuter_la_fin_des_etudes/'
                +  annee+ '/' + enseignant_id
                , '_blank')
        }
    }
    const uploadExcel = async () => {
        var enseignant_id = selectEnseignant !== "" && selectEnseignant != null ? selectEnseignant.value : 0
        if (enseignant_id === 0) {
            setLoading(true)
            toast.error("⛔  Enseignant est obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            await API.get(`excel/cahier_de_suivi_pour_discuter_la_fin_des_etudes/${annee}/${enseignant_id}`,{responseType: "blob"}
            ).then(res => {
                FileDownload(res.data, "جذاذة تأطير إجازة.xlsx")
            })

        }
    }
    const uploadExcelRepartition = async () => {
        var departement_id = selectDepartement !== "" && selectDepartement != null ? selectDepartement.value : 0
        var specialite_id = selectSpecialite !== "" && selectSpecialite != null ? selectSpecialite.value : 0

        if (departement_id === 0 || specialite_id === 0) {
            setLoading(true)
            toast.error("⛔  Département et spécialité sont obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            await API.get(`excel/Liste_des_projets_de_fin_etudes/${annee}/${departement_id}/${specialite_id}`,{responseType: "blob"}).then(res => {
                FileDownload(res.data, "قائمة مشاريع التخرج إجازة.xlsx")
            })

        }
    }
    const uploadPDFRepartition = async () => {
        var departement_id = selectDepartement !== "" && selectDepartement != null ? selectDepartement.value : 0
        var specialite_id = selectSpecialite !== "" && selectSpecialite != null ? selectSpecialite.value : 0
        if (departement_id === 0 || specialite_id === 0) {
            setLoading(true)
            toast.error("⛔  Département et spécialité sont obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            window.open('https://scolarite.backcresus-institut.ovh/api/pdf/Liste_des_projets_de_fin_etudes/' + annee + '/' + departement_id +"/"+ specialite_id, '_blank')
        }
    }
    const uploadPDFRepartitionNombre = async () => {
        var enseignant_id = selectEnseignant !== "" && selectEnseignant != null ? selectEnseignant.value : 0
        if (enseignant_id === 0) {
            setLoading(true)
            toast.error("⛔  Enseignant est obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            window.open('https://scolarite.backcresus-institut.ovh/api/pdf/cahier_de_suivi_pour_discuter_la_fin_des_etudes_master/'
              +  annee+ '/' + enseignant_id
              , '_blank')
        }

    }
    const uploadExcelRepartitionNombre = async () => {
        var enseignant_id = selectEnseignant !== "" && selectEnseignant != null ? selectEnseignant.value : 0
        if (enseignant_id === 0) {
            setLoading(true)
            toast.error("⛔  Enseignant est obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            await API.get(`excel/cahier_de_suivi_pour_discuter_la_fin_des_etudes_master/${annee}/${enseignant_id}`, {responseType: "blob"}).then(res => {
                FileDownload(res.data, "جذاذة تأطير ماجستير.xlsx")
            })
        }
    }
    const uploadPDFHeureSupp = async () => {
        var departement_id = selectDepartement !== "" && selectDepartement != null ? selectDepartement.value : 0
        var specialite_id = selectSpecialite !== "" && selectSpecialite != null ? selectSpecialite.value : 0
        if (departement_id === 0 || specialite_id === 0) {
            setLoading(true)
            toast.error("⛔  Département et spécialité sont obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            window.open('https://scolarite.backcresus-institut.ovh/api/pdf/Liste_des_projets_de_fin_etudes_master/'
              +  annee+ '/' + departement_id+"/"+specialite_id
              , '_blank')
        }
    }
    const uploadExcelHeureSupp = async () => {
        var departement_id = selectDepartement !== "" && selectDepartement != null ? selectDepartement.value : 0
        var specialite_id = selectSpecialite !== "" && selectSpecialite != null ? selectSpecialite.value : 0
        if (departement_id === 0 || specialite_id === 0) {
            setLoading(true)
            toast.error("⛔  Département et spécialité sont obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            await API.get(`excel/Liste_des_projets_de_fin_etudes_master/${annee}/${departement_id}/${specialite_id}`, { responseType: "blob" }).then(res => {
                FileDownload(res.data, "قائمة مشاريع التخرج ماجستير مهني.xlsx")
            })
        }
    }
    const uploadPDFEnseignantPer = async () => {
        window.open('https://scolarite.backcresus-institut.ovh/api/pdf/Classes_de_supervision_pour_professeurs_continentaux/' + annee, '_blank')
    }
    const uploadExcelEnseignantPer = async () => {
        await API.get(`excel/Classes_de_supervision_pour_professeurs_continentaux/${annee}`, { responseType: "blob" }).then(res => {
            FileDownload(res.data, "ساعات التأطير للمدرسين القارين.xlsx")
        })
    }
    const uploadPDFEnseignantVac = async () => {
        var departement_id = selectDepartement !== "" && selectDepartement != null ? selectDepartement.value : 0
        if (departement_id === 0) {
            setLoading(true)
            toast.error("⛔  Département est obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            window.open('https://scolarite.backcresus-institut.ovh/api/pdf/Cours_encadrement_en_deuxieme_annee_de_master_professionnel/' + annee+"/"+departement_id, '_blank')
        }
    }
    const uploadExcelEnseignantVac = async () => {
        var departement_id = selectDepartement !== "" && selectDepartement != null ? selectDepartement.value : 0
        if (departement_id === 0) {
            setLoading(true)
            toast.error("⛔  Département est obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            await API.get(`excel/Cours_encadrement_en_deuxieme_annee_de_master_professionnel/${annee}/${departement_id}`, { responseType: "blob" }).then(res => {
                FileDownload(res.data, "حصص التأطير ماجستير مهني.xlsx")
            })
        }
    }
    const uploadPDFEnseignantPerCont = async () => {
        var departement_id = selectDepartement !== "" && selectDepartement != null ? selectDepartement.value : 0
        if (departement_id === 0) {
            setLoading(true)
            toast.error("⛔  Département est obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            window.open('https://scolarite.backcresus-institut.ovh/api/pdf/Cours_encadrement_en_licence/'  + annee+"/"+departement_id, '_blank')
        }
    }
    const uploadExcelEnseignantPerCont = async () => {
        var departement_id = selectDepartement !== "" && selectDepartement != null ? selectDepartement.value : 0
        if (departement_id === 0) {
            setLoading(true)
            toast.error("⛔  Département est obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            const res = await API.get(`excel/Cours_encadrement_en_licence/${annee}/${departement_id}`, { responseType: "blob" }).then(res => {
                FileDownload(res.data, "حصص التأطير إجازة.xlsx")
            })
        }
    }
    const uploadPDFMastereRechereche = async () => {
        var enseignant_id = selectEnseignant !== "" && selectEnseignant != null ? selectEnseignant.value : 0
        if (enseignant_id === 0) {
            setLoading(true)
            toast.error("⛔  Enseignant est obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            window.open('https://scolarite.backcresus-institut.ovh/api/pdf/fiche_encadrement_mr/'  + annee+"/"+enseignant_id, '_blank')
        }
    }
    const uploadExcelMastereRechereche = async () => {
        var enseignant_id = selectEnseignant !== "" && selectEnseignant != null ? selectEnseignant.value : 0
        if (enseignant_id === 0) {
            setLoading(true)
            toast.error("⛔  Enseignant est obligatoire pour les états de l'encadrement !", {
                containerId: "A",
            })
        } else {
            const res = await API.get(`excel/fiche_encadrement_mr/${annee}/${enseignant_id}`, { responseType: "blob" }).then(res => {
                FileDownload(res.data, "حصص التأطير ماجستير بحث.xlsx")
            })
        }
    }
    const getSpec = async event => {
        var departement_id = event.value
        setSelectDepartement(event)
        const res = await API.post("pdf/get_spacialite", {
            departement_id: departement_id,annee_id
        }).then(res => {
            setSpecilaite(res.data.specialites)
        })
    }
    return (
        <React.Fragment>
            <div>
                {loading ? (
                    <Row>
                        <Form>
                            <CardTitle style={{color: "#556ee6"}} className="h4">
                                Critéres de Recherche
                            </CardTitle>
                            <Row>
                                <Col lg="4">
                                    <div className="mb-3">
                                        <Label for="basicpill-firstname-input1">Enseignant</Label>
                                        <Select
                                            options={enseignant}
                                            isSearchable={true}
                                            isClearable={true}
                                            value={selectEnseignant}
                                            onChange={e => setSelectEnseignant(e)}
                                        />
                                    </div>
                                </Col>
                                <Col lg="4">
                                    <div className="mb-3">
                                        <Label for="basicpill-firstname-input1">Département</Label>
                                        <Select
                                            options={departement}
                                            isSearchable={true}
                                            isClearable={true}
                                            value={selectDepartement}
                                            onChange={e => getSpec(e)}
                                        />
                                    </div>
                                </Col>
                                <Col lg="4">
                                    <div className="mb-3">
                                        <Label for="basicpill-firstname-input1">Spécialité</Label>
                                        <Select
                                            options={specilaite}
                                            isSearchable={true}
                                            isClearable={true}
                                            value={selectSpecialite}
                                            onChange={e => setSelectSpecialite(e)}
                                        />
                                    </div>
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {imp === 1 ? (
                                        <div className="text-center mt-4">
                                            <a className="btn  mb-2 me-2" onClick={uploadPDF}
                                               style={{height: "80px", borderColor: "#7d7b7b", width: "100%"}}
                                               target="_blank"
                                               rel="noreferrer"
                                            ><i
                                                style={{
                                                    color: "#761C19",
                                                    cursor: "pointer",
                                                    fontSize: "30px",
                                                    margin: "0px 6px 0px 0px"
                                                }}
                                                className="fas fa-file-pdf"
                                            ></i>
                                                <p> {"جذاذة تأطير إجازة "}</p>
                                            </a>
                                        </div>
                                    ) : null}
                                </Col>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {excel === 1 ? (
                                        <div className="text-center mt-4">
                                            <a className="btn mb-2 me-2" onClick={uploadExcel}
                                               style={{
                                                   height: "80px",
                                                   backgroundColor: "none",
                                                   borderColor: "#7d7b7b",
                                                   width: "100%"
                                               }}
                                               target="_blank"
                                               rel="noreferrer"
                                            ><i
                                                style={{
                                                    color: "green",
                                                    cursor: "pointer",
                                                    fontSize: "30px",
                                                    margin: "0px 6px 0px 0px"
                                                }}
                                                className="fas fa-file-excel"
                                            ></i>
                                                <p> {"جذاذة تأطير إجازة "}</p>
                                            </a>
                                        </div>
                                    ) : null}
                                </Col>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {imp === 1 ? (
                                        <div className="text-center mt-4">
                                            <a className="btn  mb-2 me-2" onClick={uploadPDFRepartitionNombre}
                                               style={{height: "80px", borderColor: "#7d7b7b", width: "100%"}}
                                               target="_blank"
                                               rel="noreferrer"
                                            ><i
                                                style={{
                                                    color: "#761C19",
                                                    cursor: "pointer",
                                                    fontSize: "30px",
                                                    margin: "0px 6px 0px 0px"
                                                }}
                                                className="fas fa-file-pdf"
                                            ></i>
                                                <p> {"جذاذة تأطير ماجستير"}</p>
                                            </a>
                                        </div>
                                    ) : null}
                                </Col>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {excel === 1 ? (
                                        <div className="text-center mt-4">
                                            <a className="btn mb-2 me-2" onClick={uploadExcelRepartitionNombre}
                                               style={{
                                                   height: "80px",
                                                   backgroundColor: "none",
                                                   borderColor: "#7d7b7b",
                                                   width: "100%"
                                               }}
                                               target="_blank"
                                               rel="noreferrer"
                                            ><i
                                                style={{
                                                    color: "green",
                                                    cursor: "pointer",
                                                    fontSize: "30px",
                                                    margin: "0px 6px 0px 0px"
                                                }}
                                                className="fas fa-file-excel"
                                            ></i>
                                                <p> {"جذاذة تأطير ماجستير"}</p>
                                            </a>
                                        </div>
                                    ) : null}
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {imp === 1 ? (
                                        <div className="text-center mt-4">
                                            <a className="btn  mb-2 me-2" onClick={uploadPDFRepartition}
                                               style={{height: "80px", borderColor: "#7d7b7b", width: "100%"}}
                                               target="_blank"
                                               rel="noreferrer"
                                            ><i
                                                style={{
                                                    color: "#761C19",
                                                    cursor: "pointer",
                                                    fontSize: "30px",
                                                    margin: "0px 6px 0px 0px"
                                                }}
                                                className="fas fa-file-pdf"
                                            ></i>
                                                <p> {"قائمة مشاريع التخرج إجازة"}</p>
                                            </a>
                                        </div>
                                    ) : null}
                                </Col>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {excel === 1 ? (
                                        <div className="text-center mt-4">
                                            <a className="btn mb-2 me-2" onClick={uploadExcelRepartition}
                                               style={{
                                                   height: "80px",
                                                   backgroundColor: "none",
                                                   borderColor: "#7d7b7b",
                                                   width: "100%"
                                               }}
                                               target="_blank"
                                               rel="noreferrer"
                                            ><i
                                                style={{
                                                    color: "green",
                                                    cursor: "pointer",
                                                    fontSize: "30px",
                                                    margin: "0px 6px 0px 0px"
                                                }}
                                                className="fas fa-file-excel"
                                            ></i>
                                                <p> {"قائمة مشاريع التخرج إجازة"}</p>
                                            </a>
                                        </div>
                                    ) : null}
                                </Col>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {imp === 1 ? (
                                        <div className="text-center mt-4">
                                            <a className="btn  mb-2 me-2" onClick={uploadPDFHeureSupp}
                                               style={{height: "80px", borderColor: "#7d7b7b", width: "100%"}}
                                               target="_blank"
                                               rel="noreferrer"
                                            ><i
                                                style={{
                                                    color: "#761C19",
                                                    cursor: "pointer",
                                                    fontSize: "30px",
                                                    margin: "0px 6px 0px 0px"
                                                }}
                                                className="fas fa-file-pdf"
                                            ></i>
                                                <p> {"قائمة مشاريع التخرج ماجستير مهني"}</p>
                                            </a>
                                        </div>
                                    ) : null}
                                </Col>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {excel === 1 ? (
                                        <div className="text-center mt-4">
                                            <a className="btn mb-2 me-2" onClick={uploadExcelHeureSupp}
                                               style={{
                                                   height: "80px",
                                                   backgroundColor: "none",
                                                   borderColor: "#7d7b7b",
                                                   width: "100%"
                                               }}
                                               target="_blank"
                                               rel="noreferrer"
                                            ><i
                                                style={{
                                                    color: "green",
                                                    cursor: "pointer",
                                                    fontSize: "30px",
                                                    margin: "0px 6px 0px 0px"
                                                }}
                                                className="fas fa-file-excel"
                                            ></i>
                                                <p> {"قائمة مشاريع التخرج ماجستير مهني"}</p>
                                            </a>
                                        </div>
                                    ) : null}
                                </Col>
                            </Row>

                            <Row>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {imp === 1 ? (
                                      <div className="text-center mt-4">
                                          <a className="btn  mb-2 me-2" onClick={uploadPDFEnseignantPerCont}
                                             style={{height: "80px", borderColor: "#7d7b7b", width: "100%"}}
                                             target="_blank"
                                             rel="noreferrer"
                                          ><i
                                            style={{
                                                color: "#761C19",
                                                cursor: "pointer",
                                                fontSize: "30px",
                                                margin: "0px 6px 0px 0px"
                                            }}
                                            className="fas fa-file-pdf"
                                          ></i>
                                              <p> {"حصص التأطير إجازة"}</p>
                                          </a>
                                      </div>
                                    ) : null}
                                </Col>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {excel === 1 ? (
                                      <div className="text-center mt-4">
                                          <a className="btn mb-2 me-2" onClick={uploadExcelEnseignantPerCont}
                                             style={{
                                                 height: "80px",
                                                 backgroundColor: "none",
                                                 borderColor: "#7d7b7b",
                                                 width: "100%"
                                             }}
                                             target="_blank"
                                             rel="noreferrer"
                                          ><i
                                            style={{
                                                color: "green",
                                                cursor: "pointer",
                                                fontSize: "30px",
                                                margin: "0px 6px 0px 0px"
                                            }}
                                            className="fas fa-file-excel"
                                          ></i>
                                              <p> {"حصص التأطير إجازة"}</p>
                                          </a>
                                      </div>
                                    ) : null}
                                </Col>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {imp === 1 ? (
                                        <div className="text-center mt-4">
                                            <a className="btn  mb-2 me-2" onClick={uploadPDFEnseignantVac}
                                               style={{height: "80px", borderColor: "#7d7b7b", width: "100%"}}
                                               target="_blank"
                                               rel="noreferrer"
                                            ><i
                                                style={{
                                                    color: "#761C19",
                                                    cursor: "pointer",
                                                    fontSize: "30px",
                                                    margin: "0px 6px 0px 0px"
                                                }}
                                                className="fas fa-file-pdf"
                                            ></i>
                                                <p> {"حصص التأطير ماجستير مهني"}</p>
                                            </a>
                                        </div>
                                    ) : null}
                                </Col>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {excel === 1 ? (
                                        <div className="text-center mt-4">
                                            <a className="btn mb-2 me-2" onClick={uploadExcelEnseignantVac}
                                               style={{
                                                   height: "80px",
                                                   backgroundColor: "none",
                                                   borderColor: "#7d7b7b",
                                                   width: "100%"
                                               }}
                                               target="_blank"
                                               rel="noreferrer"
                                            ><i
                                                style={{
                                                    color: "green",
                                                    cursor: "pointer",
                                                    fontSize: "30px",
                                                    margin: "0px 6px 0px 0px"
                                                }}
                                                className="fas fa-file-excel"
                                            ></i>
                                                <p> {"حصص التأطير ماجستير مهني"}</p>
                                            </a>
                                        </div>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row style={{display: "flex", justifyContent: "center"}}>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {imp === 1 ? (
                                      <div className="text-center mt-4">
                                          <a className="btn  mb-2 me-2" onClick={uploadPDFEnseignantPer}
                                             style={{height: "80px", borderColor: "#7d7b7b", width: "100%"}}
                                             target="_blank"
                                             rel="noreferrer"
                                          ><i
                                            style={{
                                                color: "#761C19",
                                                cursor: "pointer",
                                                fontSize: "30px",
                                                margin: "0px 6px 0px 0px"
                                            }}
                                            className="fas fa-file-pdf"
                                          ></i>
                                              <p> {"ساعات التأطير للمدرسين القارين"}</p>
                                          </a>
                                      </div>
                                    ) : null}
                                </Col>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {excel === 1 ? (
                                      <div className="text-center mt-4">
                                          <a className="btn mb-2 me-2" onClick={uploadExcelEnseignantPer}
                                             style={{
                                                 height: "80px",
                                                 backgroundColor: "none",
                                                 borderColor: "#7d7b7b",
                                                 width: "100%"
                                             }}
                                             target="_blank"
                                             rel="noreferrer"
                                          ><i
                                            style={{
                                                color: "green",
                                                cursor: "pointer",
                                                fontSize: "30px",
                                                margin: "0px 6px 0px 0px"
                                            }}
                                            className="fas fa-file-excel"
                                          ></i>
                                              <p> {"ساعات التأطير للمدرسين القارين"}</p>
                                          </a>
                                      </div>
                                    ) : null}
                                </Col>
                            </Row>
                            <Row style={{display: "flex", justifyContent: "center"}}>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {imp === 1 ? (
                                      <div className="text-center mt-4">
                                          <a className="btn  mb-2 me-2" onClick={uploadPDFMastereRechereche}
                                             style={{height: "80px", borderColor: "#7d7b7b", width: "100%"}}
                                             target="_blank"
                                             rel="noreferrer"
                                          ><i
                                            style={{
                                                color: "#761C19",
                                                cursor: "pointer",
                                                fontSize: "30px",
                                                margin: "0px 6px 0px 0px"
                                            }}
                                            className="fas fa-file-pdf"
                                          ></i>
                                              <p> {"جذاذة تأطير ماجستير بحث"}</p>
                                          </a>
                                      </div>
                                    ) : null}
                                </Col>
                                <Col lg="3" style={{textAlign: "center"}}>
                                    {excel === 1 ? (
                                      <div className="text-center mt-4">
                                          <a className="btn mb-2 me-2" onClick={uploadExcelMastereRechereche}
                                             style={{
                                                 height: "80px",
                                                 backgroundColor: "none",
                                                 borderColor: "#7d7b7b",
                                                 width: "100%"
                                             }}
                                             target="_blank"
                                             rel="noreferrer"
                                          ><i
                                            style={{
                                                color: "green",
                                                cursor: "pointer",
                                                fontSize: "30px",
                                                margin: "0px 6px 0px 0px"
                                            }}
                                            className="fas fa-file-excel"
                                          ></i>
                                              <p> {"جذاذة تأطير ماجستير بحث"}</p>
                                          </a>
                                      </div>
                                    ) : null}
                                </Col>
                            </Row>
                        </Form>


                    </Row>

                ) : (
                    <div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            {" "}
                            <Spinner type="grow" className="ms-6" color="primary"/>
                        </div>
                        <h4
                            style={{textAlign: "center", marginTop: "2%"}}
                            className="ms-6"
                        >
                            {" "}
                            En cours ...{" "}
                        </h4>
                    </div>
                )}
            </div>
            <ToastContainer
                transition={Slide}
                enableMultiContainer
                containerId={"A"}
                position={toast.POSITION.TOP_RIGHT}
                autoClose={2500}
            />
        </React.Fragment>
    )
}

export default withRouter(DataTablePlanEtudeEtat)
DataTablePlanEtudeEtat.propTypes = {
    orders: PropTypes.array,
    history: PropTypes.object,
}
